<!-- IcemaParagraphLanding.svelte — paleta fría -->
<script>
  export let companyName = "Icema";
  export let contactEmail = "administracion@icema.com.ar";
  export let brand = "#3BB7FF"; // azul hielo por defecto
  const copy = `Brindamos servicios de cadena de frío y consultoría técnico‑regulatoria para la industria farmacéutica y de productos médicos. Ofrecemos kits térmicos calificados 2–8 °C, mapeos y monitoreos de temperatura, auditorías internas, calificación de áreas y transportes, y asesoramiento integral según normativas nacionales e internacionales (ANMAT 2069/18, OMS, entre otras). Acompañamos cada proyecto con reportes, instructivos y soporte técnico para asegurar la trazabilidad y calidad en toda la operación logística.`;
</script>

<div class="row">
    <div class="col-2 col-lg-7 linea">
    </div>
     <div class="col-10 col-lg-5">
        <h2>Servicios</h2>
    </div>
</div>

<section class="hero" style={`--brand:${brand}`}>
  <div class="wrap">
    <div class="panel">
      <h1>Cadena de Frío & Consultoría Regulatoria</h1>
      <p class="lead">{copy}</p>
      <div class="cta">
        <a class="btn primary" href={`mailto:${contactEmail}?subject=Consulta%20Servicios%20${companyName}`}>Contactar</a>
      </div>
    </div>
  </div>
</section>

<style>
  :global(:root){--ink:#E7F3FF;--muted:#BBD6FF;--line:rgba(255,255,255,.16)}
  /* Fondo gélido con degradé profundo y "bruma" */
  .hero{position:relative;isolation:isolate;background:linear-gradient(180deg,#06101F,#0A1B32 55%,#0A1526);color:var(--ink);overflow:hidden}
  .wrap{max-width:1040px;margin:0 auto;padding:3.2rem 1.25rem;font-family:system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,"Helvetica Neue",Arial}

  /* Tarjeta de vidrio esmerilado */
  .panel{backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);background:linear-gradient(180deg,rgba(255,255,255,.08),rgba(255,255,255,.04));border:1px solid var(--line);border-radius:18px;padding:1.6rem;text-align:center;box-shadow:0 10px 30px rgba(0,0,0,.25)}
  h1{font-size:clamp(1.7rem,1.1rem + 2.2vw,2.7rem);margin:.2rem 0 .65rem;color:#F2F8FF;letter-spacing:.2px}
  .lead{max-width:75ch;margin:.25rem auto 1.25rem;color:#D6E9FF;line-height:1.58}

  /* Botón con tono hielo */
  .cta{display:flex;gap:.85rem;justify-content:center;flex-wrap:wrap}
  .btn{display:inline-block;border-radius:12px;padding:.85rem 1.15rem;font-weight:800;text-decoration:none;transition:transform .18s ease, filter .18s ease}
  .btn:hover{transform:translateY(-1px);filter:brightness(1.06)}
  .primary{background:color-mix(in oklab,var(--brand) 90%, white 10%);color:#031427}
  /* Nieve fina (ruido) */
  .hero::before{content:"";position:absolute;inset:0;background:radial-gradient(2px 2px at 20% 30%,rgba(255,255,255,.08),transparent 60%),radial-gradient(2px 2px at 70% 60%,rgba(255,255,255,.06),transparent 60%),radial-gradient(1.5px 1.5px at 40% 80%,rgba(255,255,255,.05),transparent 60%);pointer-events:none;opacity:.6}

  @media (max-width:600px){.panel{padding:1.1rem}}
</style>
